// Face recognition for the Annaprasadam duplicate check (face-api, runs in the browser).
// The library and models (~7 MB, cached by the browser) load only on the Issue page when the check is on.
let loading = null;

export function loadFace() {
  if (!loading) {
    loading = (async () => {
      const faceapi = await import("@vladmandic/face-api");
      try { await faceapi.tf.setBackend("webgl"); } catch { /* falls back to the default backend */ }
      await faceapi.tf.ready();
      const url = "/models/face";
      await Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(url),
        faceapi.nets.faceLandmark68Net.loadFromUri(url),
        faceapi.nets.faceRecognitionNet.loadFromUri(url),
      ]);
      return faceapi;
    })().catch((e) => { loading = null; throw e; });
  }
  return loading;
}

// 128-number face template of the single face in the image / canvas, or null when no face is found.
export async function faceTemplate(input) {
  const faceapi = await loadFace();
  const det = await faceapi
    .detectSingleFace(input, new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.5 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
  return det ? Array.from(det.descriptor, (v) => Math.round(v * 1e5) / 1e5) : null;
}

// Position of the face in a video frame (fast: detector only), or null; used for the live green box.
export async function faceBox(input) {
  const faceapi = await loadFace();
  const det = await faceapi.detectSingleFace(input, new faceapi.TinyFaceDetectorOptions({ inputSize: 224, scoreThreshold: 0.5 }));
  return det ? det.box : null;
}
